import { useRef } from "react";
import { formStates } from "../../store/formStates";
import { store } from "../../store/store";
import { useSaveFormStateMutation } from "../../api/formStates/useSaveFormStateMutation";

const { selectors } = formStates;

export const useSave = () => {
  const calledTimes = useRef(0);

  const { mutateAsync, isLoading } = useSaveFormStateMutation();

  const initiate = async () => {
    if (!calledTimes.current) {
      const preserved = selectors.getLatest(store.getState());
      if (preserved) {
        calledTimes.current += 1;
        return mutateAsync({
          path: preserved.path,
          data: preserved.data,
        });
      } else {
        return Promise.resolve("No preserved data");
      }
    }
    return Promise.resolve("Already called");
  };

  return {
    initiate,
    isLoading,
  };
};
